<style lang="scss" scoped>
.category-row,
.landing-row,
.stories-row {
    width: 100%;
    display: flex;
    flex-flow: row;
    height: auto;

    a {
        top: 0;
        &:after {
            content: "";
            z-index: 1;
            top: 0;
            left: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            background-image: linear-gradient(
                225deg,
                rgba(0, 0, 0, 0) 0%,
                rgba(0, 0, 0, 0.5) 100%
            );
        }
    }

    .category-image {
        flex-shrink: 0;
        width: 50%;
        position: relative;
        cursor: pointer;
        transition: all 0.2s ease-out;

        .link-arrow {
            display: block;
            transition: all 0.2s ease-out;
            opacity: 0;
            margin-bottom: -19px;
            margin-top: 0px;
        }

        .zoom-wrapper {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            transition: all 0.2s ease-out;
        }

        .image-wrapper {
            overflow: hidden;
            position: relative;
            transition: all 0.2s ease-out;

            div {
                width: 100%;
                height: 100%;
                transition: all 0.2s ease-out;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;

                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }

        .content {
            position: absolute;
            padding: 24px;
            bottom: 0px;
            left: 0px;
            z-index: 2;
            transition: all 0.2s ease-out;

            .title {
                line-height: 42px;
            }
        }

        &.floating {
            .content {
                width: 85%;
            }
        }

        &:first-child {
            @media (min-width: 768px) {
                .content {
                    left: auto;
                    right: 0;
                }
            }
        }

        &:nth-child(n + 3) {
            display: none;
        }

        @media (min-width: 768px) {
            width: 33.33%;
            width: calc(100% / 3);

            &:nth-child(n + 3) {
                display: block;
            }
        }

        @media (min-width: 1024px) {
            width: 25%;
        }

        @media (min-width: 1280px) {
            width: 20%;

            &.descending {
                z-index: 3;
            }

            &.floating {
                z-index: 3;

                .zoom-wrapper {
                    width: calc(100% * 1.15);
                    height: calc(100% * 1.15);
                }

                .image-wrapper {
                    border-radius: 4px;
                    box-shadow: 0 0 20px -5px rgba(0, 0, 0, 0.4);

                    div {
                        width: calc(100% * 1.1);
                        height: calc(100% * 1.1);
                    }
                }

                .link-arrow {
                    opacity: 1;
                    margin-bottom: 0px;
                    margin-top: 16px;
                }
            }
        }
    }
}
</style>

<template>
    <div class="row">
        <div v-if="pages" class="category-row">
            <div
                class="category-image"
                @mouseenter="floatElement"
                @mouseleave="unfloatElement"
                v-for="(page, index) in filteredPages"
                :key="index"
            >
                <div
                    class="ar"
                    :style="{ 'padding-top': `${(arHeight / arWidth) * 100}%` }"
                >
                    <div class="zoom-wrapper">
                        <a
                            :href="route('nl.category', { slug: page.slug })"
                            class="w-100 h-100 d-inline-block position-absolute"
                        >
                            <div class="image-wrapper w-100 h-100">
                                <div
                                    :style="{
                                        'background-image': `url(${
                                            page.acf != [] &&
                                            page.acf.meta &&
                                            page.acf.meta.image
                                                ? page.acf.meta.image.sizes
                                                      .large
                                                : ''
                                        }), linear-gradient(225deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)`
                                    }"
                                ></div>
                            </div>
                            <div class="content" :style="contentStyle">
                                <h3 class="text-white title">
                                    {{ page.name }}
                                </h3>
                                <span class="link-arrow link-white"
                                    >Bekijk alle
                                    <span
                                        class="arrow-right"
                                        v-html="svg('arrow-right')"
                                /></span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="landingpages" class="landing-row">
            <div
                class="category-image"
                @mouseenter="floatElement"
                @mouseleave="unfloatElement"
                v-for="(page, index) in landingpages"
                :key="index"
            >
                <div
                    class="ar"
                    :style="{ 'padding-top': `${(arHeight / arWidth) * 100}%` }"
                >
                    <div class="zoom-wrapper">
                        <a
                            :href="`/nl/${page.post_name}`"
                            class="w-100 h-100 d-inline-block position-absolute"
                        >
                            <div class="image-wrapper w-100 h-100">
                                <div
                                    :style="{
                                        'background-image': `url(${
                                            page.acf != [] && page.acf.image
                                                ? page.acf.image.sizes.large
                                                : ''
                                        }), linear-gradient(225deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)`
                                    }"
                                ></div>
                            </div>
                            <div class="content" :style="contentStyle">
                                <h3 class="text-white title">
                                    {{
                                        page.title != null
                                            ? page.title.rendered
                                            : page.post_title
                                    }}
                                </h3>
                                <span class="link-arrow link-white"
                                    >Bekijk alle
                                    <span
                                        class="arrow-right"
                                        v-html="svg('arrow-right')"
                                /></span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="stories" class="stories-row">
            <div
                class="category-image"
                @mouseenter="floatElement"
                @mouseleave="unfloatElement"
                v-for="(page, index) in stories"
                :key="index"
            >
                <div
                    class="ar"
                    :style="{ 'padding-top': `${(arHeight / arWidth) * 100}%` }"
                >
                    <div class="zoom-wrapper">
                        <a
                            :href="`/nl/stories/${page.post_name}`"
                            class="w-100 h-100 d-inline-block position-absolute"
                        >
                            <div class="image-wrapper w-100 h-100">
                                <div
                                    :style="{
                                        'background-image': `url(${
                                            page.acf != [] && page.acf.image
                                                ? page.acf.image.sizes.large
                                                : ''
                                        }), linear-gradient(225deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)`
                                    }"
                                ></div>
                            </div>
                            <div class="content" :style="contentStyle">
                                <h3 class="text-white title">
                                    {{
                                        page.title != null
                                            ? page.title.rendered
                                            : page.post_title
                                    }}
                                </h3>
                                <span class="link-arrow link-white"
                                    >Bekijk alle
                                    <span
                                        class="arrow-right"
                                        v-html="svg('arrow-right')"
                                /></span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import floatingElements from "../mixins/floating-elements";

export default {
    name: "pagePart.category-images-row",

    mixins: [floatingElements],

    props: {
        pages: {
            type: Array,
            required: false,
            default: null
        },

        landingpages: {
            type: Array,
            required: false,
            default: null
        },

        stories: {
            type: Array,
            required: false,
            default: null
        },

        filter: {
            type: Array,
            required: false,
            default: null
        },

        ratio: {
            type: [String, Boolean],
            default: "310:440",
            required: false
        }
    },

    data: vm => ({
        contentWidth: "100%"
    }),

    mounted() {
        // get content width from first .content element
        this.contentWidth =
            this.$el.querySelector(".content").offsetWidth + "px";

        // set content width on resize
        window.addEventListener("resize", () => {
            this.contentWidth =
                this.$el.querySelector(".content").offsetWidth + "px";
        });
    },

    computed: {
        arWidth() {
            if (!this.ratio) return 0;
            return this.ratio.split(":")[0];
        },

        arHeight() {
            if (!this.ratio) return 0;
            return this.ratio.split(":")[1];
        },

        filteredPages() {
            if (this.filter != null && this.filter.length > 0) {
                let filterslugs = [];

                for (let i = 0; i < this.filter.length; i++) {
                    filterslugs.push(this.filter[i].slug);
                }

                return this.pages.filter(page =>
                    filterslugs.includes(page.slug)
                );
            } else {
                return this.pages;
            }
        },

        contentStyle() {
            return {
                width: this.contentWidth
            };
        }
    }
};
</script>
